import type { DocumentError } from 'apiConnector/document/document';
import { DocumentFormat } from 'epic/common-form/Documentation';
import type { DocumentType } from 'models/documents/DocumentType';
export type DocumentDownloadActions = DocumentDownloadFailed | DocumentDownloaded | DocumentDownloadStart;

export function documentDownloadFailed(
  tabId: string,
  locale: string,
  error: DocumentError,
  document: string | DocumentType,
  documentFormat: DocumentFormat,
) {
  return {
    type: 'DOCUMENT_DOWNLOAD_FAILED' as const,
    tabId,
    locale,
    error,
    document,
    documentFormat,
  };
}
export type DocumentDownloadFailed = ReturnType<typeof documentDownloadFailed>;

export function documentDownloadStart(
  tabId: string,
  locale: string,
  document: string | DocumentType,
  documentFormat: DocumentFormat,
) {
  return {
    type: 'DOCUMENT_DOWNLOAD_START' as const,
    tabId,
    locale,
    document,
    documentFormat,
  };
}
export type DocumentDownloadStart = ReturnType<typeof documentDownloadStart>;

export function documentDownloaded(
  tabId: string,
  locale: string,
  document: string | DocumentType,
  documentFormat: DocumentFormat,
) {
  return {
    type: 'DOCUMENT_DOWNLOADED' as const,
    tabId,
    locale,
    document,
    documentFormat,
  };
}
export type DocumentDownloaded = ReturnType<typeof documentDownloaded>;
